'use client';

import { useEffect, useState, useRef, useContext } from 'react';
import cn from "clsx";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import type { Swiper as SwiperType } from 'swiper';
import 'swiper/css';
import styles from './index.module.scss';
import { ModalContext } from '@/context/ModalContext';
import { IModalActions, ModalTypes } from '@/types/modal';

interface SentBy {
  name: string;
  avatar?: string;
  title?: string;
}


export const TestimonialText = ({ text,sent_by,rating }: { text: string,sent_by:SentBy,rating:number}) => {
  const [showMore, setShowMore] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const { modalDispatch } = useContext(ModalContext);

  const handleTestimonial = () => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.TestimonialModal,
        modalData: { text, sent_by, rating },
      }
    })
  }

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowing(textRef.current.scrollHeight > textRef.current.clientHeight);
    }
  }, [text]);

  return (
    <div className={styles.textWrapper}>
      <div
        ref={textRef}
        className={`${styles.text} ${!showMore ? styles.collapsed : ''}`}
      >
        {`${text}`}
      </div>
      {isOverflowing && (
        <button className={styles.button} onClick={() => handleTestimonial()}>
          {showMore ? 'Show less' : 'Show more'}
        </button>
      )}
    </div>
  );
};

const TestimonialsPage = ({ testimonials, stuStoryPagination = false ,isLandingPage=false}) => {

  const swiperRef = useRef<SwiperType | null>(null);


  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.update();
    }
  }, [testimonials]);

  return (
    (testimonials?.length > 1 ?
    //  <div className={styles.root}>
      <div className={cn(styles.root, {[styles.container]: isLandingPage  }) }>
         <div className={cn({[styles.innerContainer]: isLandingPage })}>
      <Swiper
        modules={[Pagination, Autoplay]} // 👈 This is key
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        spaceBetween={20}
        slidesPerView={1}
        autoplay={{
          delay: 5000,
        }}
        breakpoints={{
          320: {
            slidesPerView: 1
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 10
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          1600: {
            slidesPerView: 3,
            spaceBetween: 20
          }
        }}
        pagination={{
          el: `${stuStoryPagination ? '.stu_story_pagination' : '.custom-swiper-pagination'}`,
          clickable: true,
          bulletElement: 'div',
        }}
      >
        {testimonials.map((item, index) => (
          <SwiperSlide key={index}>
            <div className={styles.card}>
              <div className={styles.header}>
                <img
                  src={item?.sent_by?.avatar || 'https://static.amityonline.com/_s/avatar_nerd_man_vector_42477860_removebg_preview_68cec19df4_d0073b7893.webp'}
                  alt={item?.sent_by?.name}
                  className={styles.avatar}
                  loading='lazy'
                />
                <div className={styles.nameDiv}>
                  <div className={styles.name}>{item?.sent_by?.name}</div>
                  {item?.sent_by?.title && <div className={styles.title}>{item?.sent_by?.title}</div>}
                </div>
              </div>
              <div className={styles.stars}>
                {Array.from({ length: 5 }).map((_, i) => (
                  <span key={i}>{i < item?.rating ? '★' : '☆'}</span>
                ))}
              </div>


              <TestimonialText {...item} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      </div>
      <div className={`${stuStoryPagination ? 'stu_story_pagination' : 'custom-swiper-pagination'} flex justify-center mt-6 min-w-[100px] px-4 py-2`}></div>
    </div> : testimonials?.length > 0? 
<div className={`${styles.root} ${styles.singleWrapper}`}>
    <div className={styles.card}>
      <div className={styles.header}>
        <img
          src={
            testimonials[0]?.sent_by?.avatar ||
            'https://static.amityonline.com/_s/avatar_nerd_man_vector_42477860_removebg_preview_68cec19df4_d0073b7893.webp'
          }
          alt={testimonials[0]?.sent_by?.name}
          className={styles.avatar}
        />
        <div className={styles.nameDiv}>
          <div className={styles.name}>{testimonials[0]?.sent_by?.name}</div>
          {testimonials[0]?.sent_by?.title && (
            <div className={styles.title}>{testimonials[0]?.sent_by?.title}</div>
          )}
        </div>
      </div>
      <div className={styles.stars}>
        {Array.from({ length: 5 }).map((_, i) => (
          <span key={i}>{i < testimonials[0]?.rating ? '★' : '☆'}</span>
        ))}
      </div>
      <TestimonialText {...testimonials[0]} />
    </div>
  </div>:null)
  );
};


export default TestimonialsPage;
